import {useRef, useState} from 'react';

export const usePersonalizedFiltersDropdown = () => {
  const [isYourFiltersDropdownOpen, setIsYourFiltersDropdownOpen] =
    useState(false);

  const shouldShowSavedSuccessMessage = useRef(false);

  const openYourFiltersDropdown = (showSavedSuccessMessage?: boolean) => {
    shouldShowSavedSuccessMessage.current = Boolean(showSavedSuccessMessage);
    setIsYourFiltersDropdownOpen(true);
  };

  const closeYourFiltersDropdown = () => {
    setIsYourFiltersDropdownOpen(false);
  };

  return {
    isYourFiltersDropdownOpen,
    openYourFiltersDropdown,
    closeYourFiltersDropdown,
    showSavedSuccessMessage: shouldShowSavedSuccessMessage.current,
  };
};
